export default __webpack_public_path__ + "static/media/mockups-mobile.9e87ebab.png";